import { createElement } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';
import { ToolbarSeparatorProps } from '.';
import cx from 'classnames';
import cn from './ToolbarSeparator.css.json';
import './ToolbarSeparator.css';

export const ToolbarSeparator = (props: ToolbarSeparatorProps) => {
  const dt = useDesignTokens();

  const toolbarSeperatorTokens = {
    bg: dt.c.colorUiBorder,
  };

  const style = renderInlineCssVars(toolbarSeperatorTokens, 'toolbar-separator');

  return (
    <div
      data-testid={props.testId}
      style={{ ...style, ...props.style }}
      className={cx(cn.toolbarSeparator, props.className)}
    />
  );
};
